/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
//
// THIS IS A GENERATED FILE
// DO NOT MODIFY IT! YOUR CHANGES WILL BE LOST
import { Inject, Injectable, Optional } from '@angular/core';
import {
  GrpcCallType,
  GrpcClient,
  GrpcClientFactory,
  GrpcEvent,
  GrpcMetadata
} from '@ngx-grpc/common';
import {
  GRPC_CLIENT_FACTORY,
  GrpcHandler,
  takeMessages,
  throwStatusErrors
} from '@ngx-grpc/core';
import { Observable } from 'rxjs';
import * as thisProto from './currency-indicator.pb';
import * as googleProtobuf000 from '@ngx-grpc/well-known-types';
import * as googleProtobuf001 from '@ngx-grpc/well-known-types';
import * as googleProtobuf002 from '@ngx-grpc/well-known-types';
import * as goal_transaction_enums003 from './goal-transaction-enums.pb';
import * as goal_transaction_type_enums004 from './goal-transaction-type-enums.pb';
import * as goal_transaction_payment_enum005 from './goal-transaction-payment-enum.pb';
import * as goal_transaction_origin_type_enum006 from './goal-transaction-origin-type-enum.pb';
import * as common_message007 from './common-message.pb';
import * as googleProtobuf008 from '@ngx-grpc/well-known-types';
import { GRPC_CURRENCY_INDICATOR_GRPC_SERVICE_CLIENT_SETTINGS } from './currency-indicator.pbconf';
/**
 * Service client implementation for currency_indicator.CurrencyIndicatorGrpcService
 */
@Injectable({ providedIn: 'any' })
export class CurrencyIndicatorGrpcServiceClient {
  private client: GrpcClient<any>;

  /**
   * Raw RPC implementation for each service client method.
   * The raw methods provide more control on the incoming data and events. E.g. they can be useful to read status `OK` metadata.
   * Attention: these methods do not throw errors when non-zero status codes are received.
   */
  $raw = {
    /**
     * Unary call: /currency_indicator.CurrencyIndicatorGrpcService/Get
     *
     * @param requestMessage Request message
     * @param requestMetadata Request metadata
     * @returns Observable<GrpcEvent<common_message007.CurrencyIndicatorModel>>
     */
    get: (
      requestData: common_message007.BaseGetRequest,
      requestMetadata = new GrpcMetadata()
    ): Observable<GrpcEvent<common_message007.CurrencyIndicatorModel>> => {
      return this.handler.handle({
        type: GrpcCallType.unary,
        client: this.client,
        path: '/currency_indicator.CurrencyIndicatorGrpcService/Get',
        requestData,
        requestMetadata,
        requestClass: common_message007.BaseGetRequest,
        responseClass: common_message007.CurrencyIndicatorModel
      });
    },
    /**
     * Unary call: /currency_indicator.CurrencyIndicatorGrpcService/List
     *
     * @param requestMessage Request message
     * @param requestMetadata Request metadata
     * @returns Observable<GrpcEvent<thisProto.ListCurrencyIndicatorResponse>>
     */
    list: (
      requestData: common_message007.BaseListRequest,
      requestMetadata = new GrpcMetadata()
    ): Observable<GrpcEvent<thisProto.ListCurrencyIndicatorResponse>> => {
      return this.handler.handle({
        type: GrpcCallType.unary,
        client: this.client,
        path: '/currency_indicator.CurrencyIndicatorGrpcService/List',
        requestData,
        requestMetadata,
        requestClass: common_message007.BaseListRequest,
        responseClass: thisProto.ListCurrencyIndicatorResponse
      });
    },
    /**
     * Unary call: /currency_indicator.CurrencyIndicatorGrpcService/GetLastValues
     *
     * @param requestMessage Request message
     * @param requestMetadata Request metadata
     * @returns Observable<GrpcEvent<thisProto.GetLastValuesResponse>>
     */
    getLastValues: (
      requestData: googleProtobuf008.Empty,
      requestMetadata = new GrpcMetadata()
    ): Observable<GrpcEvent<thisProto.GetLastValuesResponse>> => {
      return this.handler.handle({
        type: GrpcCallType.unary,
        client: this.client,
        path: '/currency_indicator.CurrencyIndicatorGrpcService/GetLastValues',
        requestData,
        requestMetadata,
        requestClass: googleProtobuf008.Empty,
        responseClass: thisProto.GetLastValuesResponse
      });
    },
    /**
     * Unary call: /currency_indicator.CurrencyIndicatorGrpcService/GetLastValuesOnline
     *
     * @param requestMessage Request message
     * @param requestMetadata Request metadata
     * @returns Observable<GrpcEvent<thisProto.GetLastValuesOnlineResponse>>
     */
    getLastValuesOnline: (
      requestData: thisProto.GetLastValuesOnlineRequest,
      requestMetadata = new GrpcMetadata()
    ): Observable<GrpcEvent<thisProto.GetLastValuesOnlineResponse>> => {
      return this.handler.handle({
        type: GrpcCallType.unary,
        client: this.client,
        path:
          '/currency_indicator.CurrencyIndicatorGrpcService/GetLastValuesOnline',
        requestData,
        requestMetadata,
        requestClass: thisProto.GetLastValuesOnlineRequest,
        responseClass: thisProto.GetLastValuesOnlineResponse
      });
    },
    /**
     * Unary call: /currency_indicator.CurrencyIndicatorGrpcService/GetDollarSpotValue
     *
     * @param requestMessage Request message
     * @param requestMetadata Request metadata
     * @returns Observable<GrpcEvent<thisProto.GetDollarSpotValueResponse>>
     */
    getDollarSpotValue: (
      requestData: googleProtobuf008.Empty,
      requestMetadata = new GrpcMetadata()
    ): Observable<GrpcEvent<thisProto.GetDollarSpotValueResponse>> => {
      return this.handler.handle({
        type: GrpcCallType.unary,
        client: this.client,
        path:
          '/currency_indicator.CurrencyIndicatorGrpcService/GetDollarSpotValue',
        requestData,
        requestMetadata,
        requestClass: googleProtobuf008.Empty,
        responseClass: thisProto.GetDollarSpotValueResponse
      });
    },
    /**
     * Unary call: /currency_indicator.CurrencyIndicatorGrpcService/UpdateById
     *
     * @param requestMessage Request message
     * @param requestMetadata Request metadata
     * @returns Observable<GrpcEvent<common_message007.CurrencyIndicatorModel>>
     */
    updateById: (
      requestData: common_message007.CurrencyIndicatorModel,
      requestMetadata = new GrpcMetadata()
    ): Observable<GrpcEvent<common_message007.CurrencyIndicatorModel>> => {
      return this.handler.handle({
        type: GrpcCallType.unary,
        client: this.client,
        path: '/currency_indicator.CurrencyIndicatorGrpcService/UpdateById',
        requestData,
        requestMetadata,
        requestClass: common_message007.CurrencyIndicatorModel,
        responseClass: common_message007.CurrencyIndicatorModel
      });
    },
    /**
     * Unary call: /currency_indicator.CurrencyIndicatorGrpcService/RemoveById
     *
     * @param requestMessage Request message
     * @param requestMetadata Request metadata
     * @returns Observable<GrpcEvent<common_message007.BaseResponse>>
     */
    removeById: (
      requestData: common_message007.BaseRemoveByIdRequest,
      requestMetadata = new GrpcMetadata()
    ): Observable<GrpcEvent<common_message007.BaseResponse>> => {
      return this.handler.handle({
        type: GrpcCallType.unary,
        client: this.client,
        path: '/currency_indicator.CurrencyIndicatorGrpcService/RemoveById',
        requestData,
        requestMetadata,
        requestClass: common_message007.BaseRemoveByIdRequest,
        responseClass: common_message007.BaseResponse
      });
    },
    /**
     * Unary call: /currency_indicator.CurrencyIndicatorGrpcService/Add
     *
     * @param requestMessage Request message
     * @param requestMetadata Request metadata
     * @returns Observable<GrpcEvent<common_message007.CurrencyIndicatorModel>>
     */
    add: (
      requestData: thisProto.AddCurrencyIndicatorRequest,
      requestMetadata = new GrpcMetadata()
    ): Observable<GrpcEvent<common_message007.CurrencyIndicatorModel>> => {
      return this.handler.handle({
        type: GrpcCallType.unary,
        client: this.client,
        path: '/currency_indicator.CurrencyIndicatorGrpcService/Add',
        requestData,
        requestMetadata,
        requestClass: thisProto.AddCurrencyIndicatorRequest,
        responseClass: common_message007.CurrencyIndicatorModel
      });
    }
  };

  constructor(
    @Optional()
    @Inject(GRPC_CURRENCY_INDICATOR_GRPC_SERVICE_CLIENT_SETTINGS)
    settings: any,
    @Inject(GRPC_CLIENT_FACTORY) clientFactory: GrpcClientFactory<any>,
    private handler: GrpcHandler
  ) {
    this.client = clientFactory.createClient(
      'currency_indicator.CurrencyIndicatorGrpcService',
      settings
    );
  }

  /**
   * Unary call @/currency_indicator.CurrencyIndicatorGrpcService/Get
   *
   * @param requestMessage Request message
   * @param requestMetadata Request metadata
   * @returns Observable<common_message007.CurrencyIndicatorModel>
   */
  get(
    requestData: common_message007.BaseGetRequest,
    requestMetadata = new GrpcMetadata()
  ): Observable<common_message007.CurrencyIndicatorModel> {
    return this.$raw
      .get(requestData, requestMetadata)
      .pipe(throwStatusErrors(), takeMessages());
  }

  /**
   * Unary call @/currency_indicator.CurrencyIndicatorGrpcService/List
   *
   * @param requestMessage Request message
   * @param requestMetadata Request metadata
   * @returns Observable<thisProto.ListCurrencyIndicatorResponse>
   */
  list(
    requestData: common_message007.BaseListRequest,
    requestMetadata = new GrpcMetadata()
  ): Observable<thisProto.ListCurrencyIndicatorResponse> {
    return this.$raw
      .list(requestData, requestMetadata)
      .pipe(throwStatusErrors(), takeMessages());
  }

  /**
   * Unary call @/currency_indicator.CurrencyIndicatorGrpcService/GetLastValues
   *
   * @param requestMessage Request message
   * @param requestMetadata Request metadata
   * @returns Observable<thisProto.GetLastValuesResponse>
   */
  getLastValues(
    requestData: googleProtobuf008.Empty,
    requestMetadata = new GrpcMetadata()
  ): Observable<thisProto.GetLastValuesResponse> {
    return this.$raw
      .getLastValues(requestData, requestMetadata)
      .pipe(throwStatusErrors(), takeMessages());
  }

  /**
   * Unary call @/currency_indicator.CurrencyIndicatorGrpcService/GetLastValuesOnline
   *
   * @param requestMessage Request message
   * @param requestMetadata Request metadata
   * @returns Observable<thisProto.GetLastValuesOnlineResponse>
   */
  getLastValuesOnline(
    requestData: thisProto.GetLastValuesOnlineRequest,
    requestMetadata = new GrpcMetadata()
  ): Observable<thisProto.GetLastValuesOnlineResponse> {
    return this.$raw
      .getLastValuesOnline(requestData, requestMetadata)
      .pipe(throwStatusErrors(), takeMessages());
  }

  /**
   * Unary call @/currency_indicator.CurrencyIndicatorGrpcService/GetDollarSpotValue
   *
   * @param requestMessage Request message
   * @param requestMetadata Request metadata
   * @returns Observable<thisProto.GetDollarSpotValueResponse>
   */
  getDollarSpotValue(
    requestData: googleProtobuf008.Empty,
    requestMetadata = new GrpcMetadata()
  ): Observable<thisProto.GetDollarSpotValueResponse> {
    return this.$raw
      .getDollarSpotValue(requestData, requestMetadata)
      .pipe(throwStatusErrors(), takeMessages());
  }

  /**
   * Unary call @/currency_indicator.CurrencyIndicatorGrpcService/UpdateById
   *
   * @param requestMessage Request message
   * @param requestMetadata Request metadata
   * @returns Observable<common_message007.CurrencyIndicatorModel>
   */
  updateById(
    requestData: common_message007.CurrencyIndicatorModel,
    requestMetadata = new GrpcMetadata()
  ): Observable<common_message007.CurrencyIndicatorModel> {
    return this.$raw
      .updateById(requestData, requestMetadata)
      .pipe(throwStatusErrors(), takeMessages());
  }

  /**
   * Unary call @/currency_indicator.CurrencyIndicatorGrpcService/RemoveById
   *
   * @param requestMessage Request message
   * @param requestMetadata Request metadata
   * @returns Observable<common_message007.BaseResponse>
   */
  removeById(
    requestData: common_message007.BaseRemoveByIdRequest,
    requestMetadata = new GrpcMetadata()
  ): Observable<common_message007.BaseResponse> {
    return this.$raw
      .removeById(requestData, requestMetadata)
      .pipe(throwStatusErrors(), takeMessages());
  }

  /**
   * Unary call @/currency_indicator.CurrencyIndicatorGrpcService/Add
   *
   * @param requestMessage Request message
   * @param requestMetadata Request metadata
   * @returns Observable<common_message007.CurrencyIndicatorModel>
   */
  add(
    requestData: thisProto.AddCurrencyIndicatorRequest,
    requestMetadata = new GrpcMetadata()
  ): Observable<common_message007.CurrencyIndicatorModel> {
    return this.$raw
      .add(requestData, requestMetadata)
      .pipe(throwStatusErrors(), takeMessages());
  }
}
